var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import { AccordionSummary as MuiAccordionSummary } from '@material-ui/core';
import { clickableStyle, makeStyles } from "../../styles/index";
import { ListOpen } from "../../icons/index";
var useOverwriteStyles = makeStyles(function (theme) { return ({
    root: {
        height: function (props) { var _a; return (_a = props.height) !== null && _a !== void 0 ? _a : 'auto'; },
        backgroundColor: function (props) { return props.backgroundColor; },
        padding: 0,
        '&:hover': {},
        '&$focused': {},
    },
    expandIcon: {
        marginRight: theme.spacing(0.5),
        order: -1,
        padding: 0,
        '&$expanded': {
            transform: 'rotate(90deg)',
        },
    },
    content: {
        alignItems: 'center',
    },
    focused: {},
    expanded: {},
}); });
var useStyles = makeStyles(function (theme) { return ({
    root: {},
    clickable: __assign({}, clickableStyle(theme)),
    iconColor: {
        color: theme.palette.common.black,
    },
}); }, { name: 'SnAccordionSummary' });
export var AccordionSummary = function (props) {
    var children = props.children, className = props.className, style = props.style;
    var classes = useStyles(props);
    var overwriteClasses = useOverwriteStyles(props);
    return (React.createElement("div", { className: classNames(classes.root, classes.clickable) },
        React.createElement(MuiAccordionSummary, { children: children, className: className, classes: overwriteClasses, expandIcon: React.createElement(ListOpen, { className: classes.iconColor }), style: __assign(__assign({}, style), { minHeight: 48 }) })));
};
